import { createContext, useContext } from "react";

export const BreadcrumbContext = createContext();

export function useBreadcrumbContext() {
  return useContext(BreadcrumbContext);
}
